import { render, staticRenderFns } from "./cms.vue?vue&type=template&id=2df624b6&"
import script from "./cms.vue?vue&type=script&lang=js&"
export * from "./cms.vue?vue&type=script&lang=js&"
import style0 from "./cms.vue?vue&type=style&index=0&id=2df624b6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports